var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrangeBannerMobile(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 648.203,
    height: 608.516,
    viewBox: "0 0 648.203 608.516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Forma_portocalie_mare",
    "data-name": "Forma portocalie mare",
    d: "M76.627,366.609c114.891,60.5,285.784,8.313,355.018-48.14C521.612,245.1,557.53,82.777,461.147,20.113c-54.883-35.672-142.181-30.049-210.19,67.5-63.139,90.562-111.53,44.559-184.493,69.644C-25.856,188.994-21.567,314.9,76.627,366.609Z",
    transform: "translate(208.591) rotate(32)",
    fill: "#ffdc9c"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeBannerMobile);
export default __webpack_public_path__ + "static/media/orangeBannerMobile.95e1d681e8ad4839116aceda689ee391.svg";
export { ForwardRef as ReactComponent };